import React, { useEffect, useState } from "react";
import "./NewsCarousel.css";
import axios from "axios";

function NewsGrid() {
  const [news, setNews] = useState([]);

  useEffect(() => {
    axios
      .get("https://api.stockastix.com/economic/news/")
      .then((res) => {
        setNews(res.data.news_data?.content.slice(0, 10) || []);
      })
      .catch((err) => {
        console.error("Failed to fetch news", err);
      });
  }, []);

  return (
    <div className="news-grid-section">
      <h2 className="grid-heading">📈 Economic News</h2>
      <div className="news-grid">
        {news.map((item, index) => (
          <a
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            className="news-tile"
            key={index}
          >
            <div className="tile-content">
              <h3 className="tile-title">{item.title}</h3>
              <p className="tile-meta">
                {item.author && <span>{item.author}</span>}
                {item.author ? " • " : ""}
                {new Date(item.date).toLocaleDateString()}
              </p>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}

export default NewsGrid;
